<template>
  <v-expansion-panel v-model="panel">
    <!-- Panel header -->
    <v-expansion-panel-header class="mt-2">
      AGREGAR NUEVO LOTE
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="reload()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <!-- Panel content -->
    <v-expansion-panel-content>
      <v-card>
        <Block v-if="isLoading"></Block>
        <!-- Tabs -->
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab href="#tab-1">
            AGREGAR NUEVO LOTE
            <v-icon>mdi-map-plus</v-icon>
          </v-tab>
        </v-tabs>
        <!-- Tabs content -->
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-1">
            <v-card flat class="pa-1 position-relative">
              <RealStateLotForm />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
    import {mapState} from 'vuex';
    import Block from '@/components/Block.vue';
    import RealStateLotForm from './RealStateLotForm.vue';

    export default {
      name: 'AddRealStateLot',
      components: {
        Block,
        RealStateLotForm
      },
      props:['win'],
      data() {
        return {
          isLoading: false,
          panel: 0,
          tab: null,
        }
      },
      computed: {
        ...mapState(
          'rolesUser',
          {
            rolesStatus: (state) => state.roles,
          }
        )
      },
      methods: {
        reload() {
          this.$store.dispatch('rolesUser/getAllRoles');
        }
      },
      mounted(){
        this.$store.dispatch('rolesUser/getAllRoles')
      }
    }
</script>